import { api } from "api/api"
import IndicadorDashboard from "components/chart/IndicadorDashboard"
import { ChartLineModel } from "model/chart/ChartLineModel"
import ManutencaoDashboardTable from "model/gestao/frotas/ManutencaoDashboardTable"

export default class GestaoFrotasDashboardService {

    buscarTableManutencao() {
        return new Promise<ManutencaoDashboardTable>((resolve, reject): void => {
            api.get("/gestaoFrotas/dashboard/tabela")
            .then(response => resolve(response.data))
            .catch((err) => reject(err.response))
        })
    }

    buscarChartManutencao() {
        return new Promise<ChartLineModel>((resolve, reject): void => {
            api.get("/gestaoFrotas/dashboard/chart")
            .then(response => resolve(response.data))
            .catch((err) => reject(err.response))
        })
    }

    buscarIndicadorMaiorGasto() {
        return new Promise<IndicadorDashboard>((resolve, reject)=>{
            api.get("/gestaoFrotas/dashboard/indicador/maiorGasto")
            .then(response => resolve(response.data))
            .catch((err) => reject(err.response))
        })
    }

    buscarIndicadorMaiorGastoAno() {
        return new Promise<IndicadorDashboard>((resolve, reject)=>{
            api.get("/gestaoFrotas/dashboard/indicador/maiorGasto/ano")
            .then(response => resolve(response.data))
            .catch((err) => reject(err.response))
        })
    }

    buscarIndicadorMaisManutencoes() {
        return new Promise<IndicadorDashboard>((resolve, reject)=>{
            api.get("/gestaoFrotas/dashboard/indicador/maisManutencoes")
            .then(response => resolve(response.data))
            .catch((err) => reject(err.response))
        })
    }

    buscarIndicadorMaisManutencoesAno() {
        return new Promise<IndicadorDashboard>((resolve, reject)=>{
            api.get("/gestaoFrotas/dashboard/indicador/maisManutencoes/ano")
            .then(response => resolve(response.data))
            .catch((err) => reject(err.response))
        })
    }
}
